import React, {Component} from 'react';
import lookups from './lookups.json'; //lookup tables for all the possible choices

class Middle extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        //draw left and right panels dynamically based on data
        var displayList = [];
        for (var index = 0; index < this.props.data.length; index++) {
            var option = this.props.data[index];
            var sp_choice = this.props.data[0].choice; //system pressure choice, impacts the force rating displayed in the choices
            var pos = "middle";
            if (index <= 8){pos = "top";} //hardcoded
            if (index >= 9){pos = "bottom";} //hardcoded

            //hide unavailable choices && force rating
            var display = option.title != "Force Rating";
            if(display){
                var arrChoices = option.choices.split(",")
                var choices=[];
                if(arrChoices[0] == "all"){
                    choices = lookups.options[index].choices;
                }else{
                    for(var i = 0; i < arrChoices.length; i++){
                        choices.push(lookups.options[index].choices[arrChoices[i]]);
                    }
                }

                if(choices.length == 1){
                    if(choices[0].title == "N/A" || choices[0].title == "No" || choices[0].title == "None")
                    {
                        display = false;
                    }
                }
            }

            if(display){ //don't display force rating as an option or options that are currently unavailable
                displayList.push(<Option key={index} index={index} data={option} pos={pos} sp_choice={sp_choice} onClick={(index, type, choiceIndex) => this.props.onClick(index, type, choiceIndex)}></Option>);
            }
        }
        return (
            <div id="middle">
                <div id="config">
                    <div id="chooser">
                        <div id="options_title">PRODUCT OPTIONS</div>
                        <div id="options">{displayList}</div>
                    </div>
                    <div id="driveworks">
                    <iframe id="dwIframe" src={this.props.url} width='100%' height="100%"></iframe>
                    </div>
                    <div id="summary">
                        <div id="summary_title">SELECTED OPTIONS</div>
                        {this.props.data.map((option, index) => <Item key={index} index={index} data={option}></Item>)}
                    </div>
                </div>
            </div>
        );
    }
}

class Option extends Component {
    constructor(props) {
        super(props);
    }
    showOptions(e){
        //if help button clicked show that info, otherwise show options
        var route = (e.target.id == "opt_help") ? "help" : "option";
        this.props.onClick(this.props.index, route);
    }
    selectChoice(choiceIndex){
        this.props.onClick(this.props.index, "choice", choiceIndex);
    }
    render() {
        return (
            <div className={"option " + (this.props.data.hilited ? "opt_selected" : "")}>
                <div className="opt_select" onClick={(e) => this.showOptions(e)}>
                    <div id="opt_help" className="opt_help"><img id="opt_help" className="opt_icon" src="images/icon.png"></img></div>
                    <div className="opt_label">{this.props.data.title.toUpperCase()}</div>
                    <div className="opt_arrow"><i className={"fas fa-angle-right"}></i></div>
                </div>
                {<Choices index={this.props.index} choices={this.props.data.choices} choice={this.props.data.choice} sp_choice={this.props.sp_choice} hilited={this.props.data.hilited} pos={this.props.pos} onClick={(choiceIndex) => this.selectChoice(choiceIndex)}></Choices>}
            </div>
        );
    }
}

class Choices extends Component {
    constructor(props) {
        super(props);
    }
    formatChoices(currIndex, arrChoices, hilited){
        //determine choices from lookup table
        var choices=[];
        if(arrChoices[0] == "all"){
            choices = lookups.options[currIndex].choices;
        }else{
            for(var i = 0; i < arrChoices.length; i++){
                choices.push(lookups.options[currIndex].choices[arrChoices[i]]);
            }
        }

        const numRows = 7;
        const numCols = Math.ceil(choices.length / numRows); //number of columns with at most the value of numRows choices in each

        var arr=[];
        var table = [];
        var index = 0;
        var count=0;
        var fr = "";

        //convert list to multi-dimensional array
        arr[count] = new Array();
        for(let col = 0; col < numCols; col++){
            for(let row = 0; row < numRows; row++){
                if(choices[index]){
                    choices[index].index = index;
                    arr[count].push(choices[index]);
                }
                index++;
            }
            count++;
            if(index < choices.length){
                arr[count] = new Array();
            }
        }

        //convert array to table
        index = 0;
        for(let row = 0; row < arr[0].length; row++){
            let children = [];
            for(let col = 0; col < arr.length; col ++){
                if(arr[col][row]){
                    var choice = arr[col][row];
                    if(choice){
                        if(currIndex == 1){ //if model number
                            fr = lookups.options[2].choices[choice.index].title; //get associated force rating
                        }
                        children.push(<Choice key={choice.index} index={choice.index} hilited={hilited} data={choice} fr={fr} onClick={(choiceIndex) => this.props.onClick(choiceIndex)}></Choice>);
                    }
                    index++;
                }
            }
            table.push(<tr key={row}>{children}</tr>);
        }

        //format and display choices
        //const numRows = 8;
        //var numColumns = Math.ceil(choices.length / numRows); //number of columns with at most the value of numRows choices in each
        //var table = [];
        //var index = 0;
        //var fr = "";
        //for (let row = 0; row <= numRows; row++) {
            //let children = [];
            //if(index <= choices.length){
                //for (let col = 0; col < numColumns; col++) {
                    //if(currIndex == 1){ //if model number
                        //fr = lookups.options[2].choices[index].title; //get associated force rating
                    //}
                    //var choice = choices[index];
                    //if(choice){
                        //children.push(<Choice key={index} index={index} hilited={hilited} data={choice} fr={fr} onClick={(choiceIndex) => this.props.onClick(choiceIndex)}></Choice>);
                    //}
                    //index++;
                //}
                //table.push(<tr key={row}>{children}</tr>);
            //}
        //}
        return table;
    }
    render() {
        if(this.props.pos == "top"){
            return (
                <div className="opt_choices" style={{display: this.props.hilited ? 'block' : 'none', top: '0'}}>
                    <table>
                        <tbody>
                            {this.formatChoices(this.props.index, this.props.choices.split(","), this.props.choice)}
                        </tbody>
                    </table>
                </div>
            );
        }else if(this.props.pos == "middle"){
            return (
                <div className="opt_choices" style={{display: this.props.hilited ? 'block' : 'none', bottom: '-15em'}}>
                    <table>
                        <tbody>
                            {this.formatChoices(this.props.index, this.props.choices.split(","), this.props.choice)}
                        </tbody>
                    </table>
                </div>
            );
        }else{
            return (
                <div className="opt_choices" style={{display: this.props.hilited ? 'block' : 'none', bottom: '0'}}>
                    <table>
                        <tbody>
                            {this.formatChoices(this.props.index, this.props.choices.split(","), this.props.choice)}
                        </tbody>
                    </table>
                </div>
            );
        }
    }
}

class Choice extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        var hilited = this.props.index == this.props.hilited;
        return (
            <td className={"opt_choice " + (hilited ? "opt_choice_selected" : "")} onClick={() => this.props.onClick(this.props.index)}>
                <div dangerouslySetInnerHTML={{__html:this.props.data.title}}></div>
                <div className="opt_fr" dangerouslySetInnerHTML={{__html:this.props.fr}}></div>
            </td>
        );
    }
}

class Item extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        var choices=[];
        var arrChoices = this.props.data.choices.split(",");
        if(arrChoices[0] == "all"){
            choices = lookups.options[this.props.index].choices;
        }else{
            for(var i = 0; i < arrChoices.length; i++){
                choices.push(lookups.options[this.props.index].choices[arrChoices[i]]);
            }
        }
        var choiceTitle = choices[this.props.data.choice].title.split("<br />").join(" ");
        var showChoice = !(choiceTitle == "None" || choiceTitle == "N/A" || choiceTitle == "No");
        return (
            <div className="item" style={{display: showChoice ? "block" : "none"}}>
                <div className="name">
                    <div>{this.props.data.title} -</div>
                    <div dangerouslySetInnerHTML={{__html:choiceTitle}}></div>
                </div>
            </div>
        );
    }
}

export default Middle;
